/**
 * CheckIcon — sanitized from `assets/newSvg/check.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function CheckIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M21.5456,5.11107 C22.1314,5.69686 22.1314,6.6466 21.5456,7.23239 L10.3026,18.4754 C9.6778,19.1002 8.66474,19.1002 8.0399,18.4754 L2.45376,12.8892 C1.86797,12.3035 1.86797,11.3537 2.45376,10.7679 C3.03954,10.1821 3.98929,10.1821 4.57508,10.7679 L9.17127,15.3641 L19.4243,5.11107 C20.0101,4.52528 20.9599,4.52528 21.5456,5.11107 Z"
        fill={color}
      />
    </Svg>
  );
}

export default CheckIcon;
